import React from 'react';

import { ColumnHeaderSortable } from '../../DataTable/index.jsx';

import Column from './base.jsx';


var columnOptions = {
  id: 'b',
  title: 'Ticker'
};


class HeaderColumn extends ColumnHeaderSortable {
  get id() {
    return columnOptions.id;
  }

  get title() {
    return columnOptions.title;
  }
}


var DetailColumn = function(props) {
  return (
    <td>{props.row.ticker.toUpperCase()}</td>
  );
}


class Ticker extends Column {
  get id() {
    return columnOptions.id;
  }

  get title() {
    return columnOptions.title;
  }

  sortAscending(a, b) {
    if (a.ticker < b.ticker) {
      return -1;
    }
    if (a.ticker > b.ticker) {
      return 1;
    }
    return super.sortAscending(a, b);
  }

  sortDescending(a, b) {
    if (a.ticker < b.ticker) {
      return 1;
    }
    if (a.ticker > b.ticker) {
      return -1;
    }
    return super.sortDescending(a, b);
  }

  get DetailColumn() {
    return DetailColumn;
  }

  get HeaderColumn() {
    return HeaderColumn;
  }
}


export default Ticker;

